import { Uploader } from "./upload_common";
import { S3Upload } from "./s3";

class VideoUploader extends Uploader {
    constructor(root) {
        super(root)

        this.videos = []
        this.completedVideos = 0
        let that = this

        this.mappingElem = $("#video_file_name_mapping")
        // Disable text selection for sortable elements
        this.mappingElem.css({
            '-webkit-user-select': 'none',
            '-moz-user-select': 'none',
            '-ms-user-select': 'none',
            'user-select': 'none'
        });

        // Native JavaScript sortable implementation
        this.makeSortable(this.mappingElem[0], () => {
            that.update_mapping(true)
        })
    }

    validateRow(target, files) {
        const container = target.closest('.uploader-container')
        const status = container.querySelector('.upload-status')

        this.videos = []
        this.completedVideos = 0

        if (files.length < 1 || files.length > 250) {
            this.statusError(status, "Please select between 1 and 250 files.")
            return
        }

        for (let file of files) {
            if (!this.isVideo(file)) {
                this.statusError(status, "Invalid file type selected. Please select only mp(e)g, mp4, webm, or avi files.")
                return
            }
        }

        this.statusSuccess(status, `${files.length} ${files.length === 1 ? 'file' : 'files'} selected`)

        this.videos = files
        this.update_mapping()

        this.submitButton.removeAttribute('disabled')
    }

    update_mapping(uploadMapping = false) {
        const mappingElem = this.root.querySelector('#video_file_name_mapping')
        const list = this.root.querySelector('#video_upload_result')
        list.innerHTML = ''

        let tr = document.createElement('tr')
        list.appendChild(tr)

        let mapping = []
        for (let li of mappingElem.querySelectorAll('li')) {
            mapping.push(li.getAttribute('data-key'))
            let th = document.createElement('th')
            th.innerText = li.innerText
            tr.appendChild(th)
        }

        // Combined size/progress column
        let th = document.createElement('th')
        th.innerText = 'Size'
        tr.appendChild(th)

        if (uploadMapping === true && mapping.length === 4) {
            const url = mappingElem.getAttribute('data-url')
            $.post(url, {
                mapping
            })
        }

        if (this.videos.length === 0) {
            list.innerHTML = ''
            let tr = document.createElement('tr')
            let td = document.createElement('td')
            td.className = 'text-sm'
            td.innerText = 'No files selected'
            tr.appendChild(td)
            list.appendChild(tr)
            return
        }

        for (let file of this.videos) {
            const filename = file.name.replace(/\.(mpe?g|mp4|webm|msvideo|avi)$/i, '')
            const values = filename.split('.');

            let tr = document.createElement('tr')
            list.appendChild(tr)

            file.mapping = {}

            for (let i = 0; i < mapping.length; i++) {
                let value = ''
                if (values.length > i) {
                    value = values[i]
                }

                let td = document.createElement('td')
                td.innerText = value
                tr.appendChild(td)

                file.mapping[mapping[i]] = value
            }

            // Combined size/progress cell
            let td = document.createElement('td')
            td.style.textAlign = 'center'
            td.innerText = (Math.round(file.size / 100000) / 10) + 'MB'
            tr.appendChild(td)
            file.sizeElem = td
            file.progress = 0

        }
    }


    doSubmit() {
        for (let file of this.videos) {
            const result = this.postVariant(file.mapping)
            if (!result?.uuid) {
                this.submitted = false
                const message = (result?.errors && Object.values(result.errors).flat()[0]) || 'Upload failed. Please try again.'
                this.uploadFailed(message)
                return
            }
            const variant = result
            const uploader = new S3Upload(variant, this)
            uploader.enqueue("videos", 1, [file])
            uploader.upload()
        }
    }

    uploadProgress(total, file, filePercent) {
        file.progress = total

        // Show progress instead of size when upload starts
        if (total > 0) {
            file.sizeElem.innerText = total + '%'
        }

        let completed = this.videos.reduce((acc, cur) => acc + cur.progress, 0)
        completed = Math.round(completed / this.videos.length)
        super.uploadProgress(completed)
    }



    uploadComplete() {
        this.completedVideos += 1

        if (this.completedVideos === this.videos.length) {
            this.submitButton.innerHTML = `Upload complete`
            this.submitButton.style.background = '#218838'
            this.submitButton.innerText = 'Upload complete'
            let that = this
            window.setTimeout(() => {
                window.location = that.form.getAttribute('data-redirect')
            }, 1000)
        }
    }
}

function initializeVideoUploaders() {
    const root = document.querySelector('#video_upload')
    if (root !== null && !root.dataset.uploaderInitialized) {
        new VideoUploader(root)
        root.dataset.uploaderInitialized = 'true'
    }
}

// Initialize on full page load (non-Turbo) and Turbo navigations
window.addEventListener('load', initializeVideoUploaders)
document.addEventListener('turbo:load', initializeVideoUploaders)
document.addEventListener('turbo:frame-load', initializeVideoUploaders)

// Make VideoUploader available globally for dynamic initialization
window.VideoUploader = VideoUploader;
